import { render, staticRenderFns } from "./AmmountForm.vue?vue&type=template&id=a4fae4ea&scoped=true&"
import script from "./AmmountForm.vue?vue&type=script&lang=js&"
export * from "./AmmountForm.vue?vue&type=script&lang=js&"
import style0 from "./AmmountForm.vue?vue&type=style&index=0&id=a4fae4ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fae4ea",
  null
  
)

export default component.exports